import SizeUtility from '../../../js/Utilities/SizeUtility.js';
import EscapeManager from '../../../js/Managers/EscapeManager.js';

class PrimaryNavItem extends HTMLElement {
  megamenu = null;
  button = null;
  megamenuID = '';
  escapeManagerID = '';

  constructor() {
    super();

    this.megamenu = this.querySelector('mega-nav');
    this.button = this.querySelector('.primary-nav__expander');

    this.setAttribute('data-menu-expanded', 'false');

    if (!this.megamenu) return;

    this.megamenuID = this.megamenu.getAttribute('id');
    this.escapeManagerID = `closeMegaMenu-${this.megamenuID}`;

    this._onButtonClick = this.onButtonClick.bind(this);
    this._onButtonMouseEnter = this.onButtonMouseEnter.bind(this);
    this._onMegaMenuClose = this.onMegaMenuClose.bind(this);
    this._onMegaMenuOpen = this.onMegaMenuOpen.bind(this);
    this._listenForOutsideClick = this.listenForOutsideClick.bind(this);
  }

  connectedCallback() {
    if (!this.megamenu) return;

    this.addEventListeners();
  }

  disconnectedCallback() {
    if (!this.megamenu) return;

    this.removeEventListeners();
  }

  addEventListeners() {
    this.button.addEventListener('click', () => this.onButtonClick());

    this.addEventListener('mouseenter', this._onButtonMouseEnter);

    this.megamenu.addEventListener('mega-nav-close', this._onMegaMenuClose);
    this.megamenu.addEventListener('mega-nav-open', this._onMegaMenuOpen);
  }

  removeEventListeners() {
    this.button.removeEventListener('click', this._onButtonClick);

    this.removeEventListener('mouseenter', this._onButtonMouseEnter);

    this.megamenu.removeEventListener('mega-nav-close', this._onMegaMenuClose);
    this.megamenu.removeEventListener('mega-nav-open', this._onMegaMenuOpen);
  }

  onButtonClick() {
    if (this.megamenu) {
      this.megamenu.toggle();
    }
  }

  onButtonMouseEnter() {
    if (!SizeUtility.isScreenGtLg()) {
      return;
    }
    this.open = true;
  }

  onMegaMenuClose() {
    if (this.button) {
      this.button.setAttribute('aria-expanded', 'false');
    }

    this.setAttribute('data-menu-expanded', 'false');

    EscapeManager.remove(this.escapeManagerID);
    this.removeOpenListeners();
  }

  onMegaMenuOpen() {
    if (this.button) {
      this.button.setAttribute('aria-expanded', 'true');
    }

    this.setAttribute('data-menu-expanded', 'true');

    EscapeManager.add(this.escapeManagerID, () => {
      this.open = false;
    });
    this.addOpenListeners();
  }

  listenForOutsideClick(evt) {
    if (!this.contains(evt.target)) {
      this.open = false;
    }
  }

  addOpenListeners() {
    document.addEventListener('click', this._listenForOutsideClick);
  }

  removeOpenListeners() {
    document.removeEventListener('click', this._listenForOutsideClick);
  }

  get open() {
    return this.megamenu?.open ?? false;
  }

  set open(value) {
    if (this.megamenu) {
      this.megamenu.open = value;
    }
  }
}

class PrimaryNav extends HTMLElement {
  connectedCallback() {
    this.PrimaryNavItems = Array.from(this.querySelectorAll('primary-nav-item'));

    this.addEventListeners();
  }

  addEventListeners() {
    this.PrimaryNavItems.forEach(item => {
      if (item.megamenu) {
        item.megamenu.addEventListener('mega-nav-open', this.closeOtherMenus.bind(this, item));
      }
    });
  }

  getOpenCount() {
    return this.PrimaryNavItems.filter(item => item.open).length;
  }

  closeOtherMenus(item = false) {
    this.PrimaryNavItems.forEach(navItem => {
      if (navItem !== item) navItem.open = false;
    });

    // Scroll this to top of item if not false
    if (item) {
      const itemTop = item.getBoundingClientRect().top;
      const navTop = this.getBoundingClientRect().top;
      this.scrollTo({ left: 0, top: itemTop - navTop, behavior: 'instant' });
    }
  }
}

customElements.define('primary-nav-item', PrimaryNavItem);
customElements.define('primary-nav', PrimaryNav);
